import React, { createContext, useEffect, useState } from "react";

export const cursorContext = createContext(null);

const CursorProvider = ({ children }) => {
  const [cursorPos, setCursorPos] = useState({
    x: 0,
    y: 0,
  });

  const [cursorBg, setCursorBg] = useState("default");

  useEffect(() => {
    const move = (e) => {
      setCursorPos({
        x: e.clientX,
        y: e.clientY,
      });
    };

    window.addEventListener("mousemove", move);

    return () => window.addEventListener("mousemove", move);
  });

  const cursorVariants = {
    default: {
      x: cursorPos.x - 16,
      y: cursorPos.y - 16,
      // backgroundColor: "#000000",
      transition: {
        delay: 0,
        duration: 0,
      },
    },
    text: {
      x: cursorPos.x - 16,
      y: cursorPos.y - 16,
      backgroundColor: "#1EABE1",
      // color: "#FFF",
      mixBlendMode: "difference",
      width: "80px",
      height: "80px",
      transition: {
        delay: 0,
        duration: 0,
      },
    },
    button: {
      x: cursorPos.x - 16,
      y: cursorPos.y - 16,
      width: "20px",
      height: "20px",
      // backgroundColor: "#000000",
      transition: {
        delay: 0,
        duration: 0,
      },
    },
  };

  const mouseButtonHandler = () => {
    setCursorBg("button");
  };

  const mouseEnterHandler = () => {
    // debugger;
    setCursorBg("text");
  };

  const mouseLeaveHandler = () => {
    setCursorBg("default");
  };

  return (
    <cursorContext.Provider
      value={{
        cursorVariants,
        cursorBg,
        mouseEnterHandler,
        mouseLeaveHandler,
        mouseButtonHandler,
      }}>
      {children}
    </cursorContext.Provider>
  );
};

export default CursorProvider;
